import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import store from "./redux/store";

import App from "./App";
import { MobileHelpers } from "./components";
import * as serviceWorker from "./serviceWorker";

export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const applicationTemplate = (
    <Provider store={store}>
      <App />
      {isMobile && <MobileHelpers />}
    </Provider>
  ),
  rootElement = document.getElementById("root");

if ( rootElement.hasChildNodes() ) {
  ReactDOM.hydrate(
    applicationTemplate,
    rootElement
  );
} else {
  ReactDOM.render(
    applicationTemplate,
    rootElement
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
